import type { SVGProps } from "react";
export const Link = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M10.8077 16.5385H7.0385C5.78283 16.5385 4.7125 16.096 3.8275 15.211C2.9425 14.3262 2.5 13.256 2.5 12.0005C2.5 10.745 2.9425 9.67465 3.8275 8.78949C4.7125 7.90415 5.78283 7.46149 7.0385 7.46149H10.8077V8.96149H7.0385C6.19867 8.96149 5.48233 9.25799 4.8895 9.85099C4.2965 10.444 4 11.1603 4 12C4 12.8397 4.2965 13.556 4.8895 14.149C5.48233 14.742 6.19867 15.0385 7.0385 15.0385H10.8077V16.5385ZM8.25 12.75V11.25H15.75V12.75H8.25ZM13.1923 16.5385V15.0385H16.9615C17.8013 15.0385 18.5177 14.742 19.1105 14.149C19.7035 13.556 20 12.8397 20 12C20 11.1603 19.7035 10.444 19.1105 9.85099C18.5177 9.25799 17.8013 8.96149 16.9615 8.96149H13.1923V7.46149H16.9615C18.2172 7.46149 19.2875 7.90399 20.1725 8.78899C21.0575 9.67382 21.5 10.744 21.5 11.9995C21.5 13.255 21.0575 14.3253 20.1725 15.2105C19.2875 16.0958 18.2172 16.5385 16.9615 16.5385H13.1923Z"
			fill="currentColor"
		/>
	</svg>
);
